import { TBookingMeeting } from '../basis/types/database/tbooking-meeting';
import { THistoryMeeting } from '../basis/types/database/thistory-meeting';
import { TMeeting } from '../basis/types/database/tmeeting';
import { TMeetingCapability } from '../basis/types/database/tmeeting-capability';
import { TMeetingRecord } from '../basis/types/database/tmeeting-record';
import { TMyMeeting } from '../basis/types/database/tmy-meeting';
import { TPerson } from '../basis/types/database/tperson';
import { TField } from '../basis/types/tfield';
import { TResponse } from '../basis/types/tresponse';
import { axiosGet, axiosPost } from '../utils/axios';
import config from '../basis/config.json';

// 获取会管能力,是否可以录制、转文字等
export const getMeetingCapability = async () => {
  const resp = await axiosGet<TResponse.Result<TMeetingCapability.Data>>(`/mgr/v1/getMeetingCapability`);

  return resp;
};

// 获取我的会议（即将开始、正在进行）包括预约和进行中会议
export const getMyMeeting = async (data: { endTime: number }) => {
  const resp = await axiosGet<TResponse.Result<TMyMeeting.Data>>(`/mgr/v1/getMyMeeting`, data);

  return resp;
};

// 获取周期性会议信息
export const getRepeatMeeting = async (data: { roomId: string; startTime: number; endTime: number }) => {
  const resp = await axiosGet<TResponse.Result<TMyMeeting.CreateItem[]>>(`/mgr/v1/getRepeatMeeting`, data);

  return resp;
};

// 取消预约的会议
export const cancelBooking = async (data: { roomId: string[] }) => {
  const resp = await axiosPost(`/mgr/v1/cancelBooking`, data);

  return resp;
};

// 新建预约会议
export const createBookingMeeting = async (data: TBookingMeeting.Data) => {
  const resp = await axiosPost<TResponse.Result<{ roomId: string; meetUrl: string }>>(`/mgr/v1/bookingMeeting`, data);

  return resp;
};

// 修改更新预约会议
export const modifyBookingMeeting = async (data: TBookingMeeting.Data) => {
  const resp = await axiosPost<TResponse.Result<{ roomId: string; meetUrl: string }>>(`/mgr/v1/modifyBooking`, data);

  return resp;
};

// 获取预约会议详情
export const getBookingDetail = async (data: { roomId: string }) => {
  const resp = await axiosGet<TResponse.Result<TBookingMeeting.Data>>(`/mgr/v1/getBookingDetail`, data);

  return resp;
};

// 获取会议详情
export const getMeetingDetail = async (data: {
  roomId: string;
  roomSid?: string;
  haveParticipant?: boolean;
  range?: TField.MeetRange;
}) => {
  const resp = await axiosGet<TResponse.Result<TMeeting.Data>>(`/mgr/v1/getMeetingDetail`, data);

  return resp;
};

// 获取会议相关记录
export const getMeetingJoinRecordList = async (data: { roomId: string; roomSid: string }) => {
  const resp = await axiosGet<TResponse.Result<TMeetingRecord.Data>>(`/mgr/v1/getJoinRecordList`, data);

  return resp;
};

// 获取历史会议记录
export const getHistoryMeetingList = async (data: {
  page: number;
  pageSize: number;
  param?: any;
  startTime?: number;
  endTime?: number;
}) => {
  const resp = await axiosGet<TResponse.Result<THistoryMeeting.Data>>(`/mgr/v1/getHistoryList`, data);

  return resp;
};

// 获取历史会议合集
export const getHistoryMeetingCollectionList = async (data: { roomId: string }) => {
  const resp = await axiosGet<TResponse.Result<THistoryMeeting.Data>>(`/mgr/v1/getHistoryCollectionList`, data);

  return resp;
};

/**
 * 加入前检查
 * @param data
 * @param data.roomId
 * @returns 返回检查数据
 */
export const checkBeforeJoin = async (data: { roomId?: string }) => {
  return await axiosPost<TResponse.Result<TPerson.User>>(`/mgr/v1/checkBeforeJoin`, {
    ...data,
    clientType: config.clientId,
  });
};
